import { getFirstObject } from "global/common/convert";
import { getFormPropz } from "global/components/forms/props/formPropz";
import { getAppFormProps } from "global/viewSettings/helpers/settingsHelpers";
import { useContext, useEffect, useState } from "react";
import { DataModifyContext } from "../DataModifyContext";
import { FrameworkContext } from "../FrameworkContent";
import { ParentContext } from "../ParentContext";

export const useFormProps = (props) => {

  const { modifyHandlers, modifyData, modifyProps, modifyViewItem } = props ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { appForms_state, currentSettings_state } = states
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appForms } = appForms_state ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frameworkRightType, frInfos, currentSwiperTab } = framework_state ?? {}
  const frInfo = frInfos && frInfos?.[currentSwiperTab]
  const { uivi, viewItem: viewItem_fr, viewListData } = frInfo ?? {}

  const dataModifyContext = useContext(DataModifyContext)
  const { dataModify_state, dataModify_handlers } = dataModifyContext ?? {}
  const { itemProps, editableItem, data_modified, dataListData } = dataModify_state ?? {}
  let { viewItem } = dataModify_state ?? {}
  if (modifyViewItem) { viewItem = modifyViewItem }

  const _itemProps = modifyProps || itemProps

  const { key: vit } = viewItem
  const _viewItem = viewItem_fr ? viewItem_fr : viewItem
  const _vit = uivi ? uivi : vit

  viewItem = aps_viewItems[_vit]

  const { item: firstData } = dataListData ? getFirstObject(dataListData) : {}

  let _modifyData = firstData ? firstData : data_modified
  if (modifyData) { _modifyData = modifyData }

  if (frameworkRightType && frInfo && viewListData) {
    const { item: frData } = getFirstObject(viewListData)
    _modifyData = frData
  }

  const [dim_state, setDimState] = useState({})

  const ammendFormProps = (viewProps) => {
    const hdls = modifyHandlers ? { ...modifyHandlers } : { ...dataModify_handlers };
    let ignorePropSections = false;
    if (editableItem) ignorePropSections = true;

    const { propSections } = viewItem ?? {};

    _.forEach(propSections, (propSection, psKey) => {
      propSection.key = psKey;
    });

    // 1️⃣ Normalize and apply the 'hidden' rule
    const _normalizedPropSections = _.map(propSections, (propSection, psKey) => ({
      ...propSection,
      show: propSection.key === 'hidden' ? false : !!propSection.show,
    }));

    // 2️⃣ Sort logic:
    // - visible (show=true) first
    // - custom ordering: description → before hidden
    // - by position
    const _sortedPropSections = _.orderBy(
      _normalizedPropSections,
      [
        // show=true first
        (s) => (s.show ? 0 : 1),

        // priority order: normal=0, description=1, hidden=2
        (s) => (s.key === 'hidden' ? 2 : s.key === 'description' ? 1 : 0),

        // position
        'position',
      ],
      ['asc', 'asc', 'asc']
    );

    // 3️⃣ Group viewProps by their propSection
    const _viewPropsGrouped = _.groupBy(viewProps, 'propSection');

    // 4️⃣ Build object keyed by position  
    const propSectionProps = _sortedPropSections.map((propSection) => ({
      section: propSection,
      items: _.sortBy(
        _viewPropsGrouped[propSection.key || propSection.id || propSection.propSection] || [],
        'position'
      ),
    }));

    const fpp = {
      data_init: _modifyData,
      editableItem,
      form_handlers: hdls,
      ignorePropSections,
      updateProps: { formKey: null },
      viewItem,
      viewProps,
    };
    const fps = getFormPropz(fpp);
    fps.propSectionProps = propSectionProps;

    setDimState({ formProps: fps, vit: _vit, viewProps: _itemProps, propSectionProps });
  };

  useEffect(() => {
    if (viewItem && appForms) {
      const appFormProps = getAppFormProps(viewItem.key, appForms)
      if (appFormProps) {
        ammendFormProps(appFormProps)
      } else {
        if (_itemProps) { ammendFormProps(_itemProps) }
      }
    } else {
      if (_itemProps) { ammendFormProps(_itemProps) }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_itemProps]);

  return dim_state

}